// 역할: 콘텐츠 영역 컨테이너 (자식 렌더링)
import type { ReactNode } from 'react';

interface ContentAreaProps {
  children?: ReactNode;
}

export const ContentArea = ({ children }: ContentAreaProps) => {
  return <div className='flex-1 flex flex-col bg-gray-100 min-h-0 overflow-hidden'>{children}</div>;
};
